import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap';
import CargosMaisContratados10Store from "../stores/CargosMaisContratados10Store";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {CustomPieChart} from "../../comum/components/CustomPieChart";
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import classnames from 'classnames';

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'EMPRESA', 'FORNECEDOR', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'PRODUTO'];

@inject("store")
@DataWrapper
@observer
export class CargosMaisContratados10 extends Component {
    constructor(props) {
        super(props);
        this.controller = new CargosMaisContratados10Store();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Os 10 cargos mais contratados");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                controller={this.controller}
                                history={this.props.history}
                                location={this.props.location}
                                fields={FILTROS} />
                        { this.controller.dados && this.controller.dados.length > 0 &&
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('1'); }}
                                            className={classnames({ active: this.controller.activeTab === '1' })} >
                                            Quantidade
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('2'); }}
                                            className={classnames({ active: this.controller.activeTab === '2' })} >
                                            Percentual
                                        </NavLink>
                                    </NavItem>
                                    { this.controller.cargoSelecionado &&
                                        <NavItem>
                                            <NavLink onClick={() => { this.controller.toggle('3'); }}
                                                className={classnames({ active: this.controller.activeTab === '3' })}>
                                                {this.controller.cargoSelecionado}
                                            </NavLink>
                                        </NavItem>
                                    }
                                </Nav>
                                <TabContent activeTab={this.controller.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <div className="text-center">Clique na barra referente ao cargo para detalhar as divisões e departamentos</div>
                                                <CustomBarChart dataKeys={["Quantidade"]} data={this.controller.dados}
                                                        onClick={(cargo) => this.controller.detalharCargo(cargo)} legend={false}
                                                        labelAxisX={"Cargo"} labelAxisY={"Quantidade"} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <div className="text-center">Clique na barra referente ao cargo para detalhar as divisões e departamentos</div>
                                                <CustomPieChart dataKey="Quantidade" data={this.controller.dados}
                                                        onClick={(cargo) => this.controller.detalharCargo(cargo)}/>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <div className="text-center">Divisões e departamentos para o cargo <strong>{this.controller.cargoSelecionado}</strong></div>
                                                <CustomBarChart stackId="1" dataKeys={this.controller.departamentos} data={this.controller.detalhes}
                                                        labelAxisX={"Divisão"} labelAxisY={"Quantidade"} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </div>
                        }
                        { this.controller.dados && this.controller.dados.length === 0 &&
                            <span>Nenhum resultado encontrado</span>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
